import { toBase64 } from '@tools/wr-catalog-base'

export const htmlToText = (html) => {
  const div = document.createElement('div')
  div.innerHTML = html
  return div.textContent
}

export const textToHtml = (maybeHtml) => {
  const div = document.createElement('div')
  div.textContent = maybeHtml
  return div.innerHTML
}

export const cleanFormatting = (html) => {
  const div = document.createElement('div')
  div.innerHTML = html
  Array.from(div.querySelectorAll('*')).forEach((node) => {
    node.style.fontFamily = ''
    node.style.fontSize = ''
    node.style.color = ''
  })
  return div.innerHTML
}

export const fetchImage = async (src) => {
  if (!src.startsWith('http')) {
    return src
  }

  try {
    const url = new window.URL(src)
    const blob = await fetch(url.pathname).then((v) => v.blob())
    const content = await toBase64(blob, true)
    const mimeType = `image/${url.pathname.split('.').slice(-1)[0]}`
    return `data:${mimeType};base64,${content}`
  } catch (e) {
    console.error(`Failed resolving ${src}`)
    console.error(e)
    return ''
  }
}
